<style lang="less" scoped>
    @import url("~@/lib/base.less");
    .preview-image {
      position: fixed;
      top: -1px;
      left: -1px;
      right: -1px;
      bottom: -1px;
      z-index: 1500;
      background: rgba(0, 0, 0, 0.8);
      .swiper-container {
        width: 100%;
        height: 100%;
        .swiper-img {
          position: absolute;
          width: 100%;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .page-number {
        position: absolute;
        bottom: .pxToRem(20) [];
        left: 50%;
        transform: translateX(-50%);
        color: white;
        font-size: .pxToRem(24) [];
        font-weight: bold;
      }
    }
</style>

<template>
    <div class="component preview-image">
        <div class="swiper-container preview-swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide"
                     v-for="(item , index) in currentUrls"
                     @click="closeSwiper"
                     :key="index">
                    <img class="swiper-img"
                         :src="item"
                         @click.stop=""
                         alt="" />
                </div>
            </div>
        </div>
        <div class="page-number"
             v-if="currentUrls.length">{{currentIndex + 1}} / {{currentUrls.length }}</div>
    </div>
</template>
<script>
    import Swiper from "@/lib/swiper3.4.2/swiper.min.js";
    import "@/lib/swiper3.4.2/swiper.min.css";
    let isOpenBack = false;
    let previewSwiper = {};
    export default {
        data() {
            return {
                currentIndex: 0,
                cssText: '',
            }
        },
        computed: {
            currentUrls() {
                if (this.urls.length == 0) {
                    return [];
                }
                let result;
                if (typeof this.urls === 'string') {
                    result = [this.urls];
                }
                else {
                    result = this.urls;
                }
                this.$nextTick(() => {
                    previewSwiper = new Swiper(".preview-swiper", {
                        direction: "horizontal",/*横向滑动*/
                        initialSlide: this.currentIndex,
                        onSlideChangeEnd: swiper => {   
                            if (swiper.activeIndex > -1) {
                                this.currentIndex = swiper.activeIndex
                            }
                            else {
                                this.currentIndex = this.currentIndex || 0
                            }
                        }
                    });
                })
                return result;
            },
        },
        props: ['urls', 'index', 'change'],
        created() {
            this.$util.lockScreen();
            this.currentIndex = Number(this.index) || 0;
            this.fobiddeBack();
        },
        methods: {
            closeSwiper() {
                this.$util.unlockScreen();
                this.enableBack();
                if (this.change) {
                    this.change({
                        close: true
                    });
                }
            },
            //防止页面后退
            fobiddeBack() {
                if (!isOpenBack) {
                    isOpenBack = true;
                    history.pushState(null, null, document.URL);
                    window.addEventListener('popstate', this.backCommon)
                }
            },
            //启用浏览器返回
            enableBack() {
                if (isOpenBack) {
                    isOpenBack = false;
                    history.go(-1);
                    window.removeEventListener('popstate', this.backCommon)
                }
            },
            backCommon() {
                history.pushState(null, null, document.URL);
                this.closeSwiper();
            }
        }
    }
</script>
